(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["five-min-new-face-2026"] && !Shopify.designMode) return;
  try {
    
  /* The original <global-static-banner-with-carousel> custom element
     is defined in sections/static-banner-with-carousel.liquid. Since
     `customElements.define` can only be called once per tag name, if
     that section is also on the page we reuse the existing class.
     If this 2026 section is the only one on the page, the original
     section's JS still defines the class via Shopify's section JS
     bundling, so no duplicate registration is needed here. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  class GalleryMobileSlider extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.gallery__inner');
      this.prevBtn = this.querySelector('.gallery-slider-arrow.prev');
      this.nextBtn = this.querySelector('.gallery-slider-arrow.next');

      if (!this.container || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this.scroll('left'));
      this.nextBtn.addEventListener('click', () => this.scroll('right'));

      this.container.addEventListener('scroll', this.updateButtons.bind(this), { passive: true });
      
      // Initial button state check
      setTimeout(() => this.updateButtons(), 100);
    }

    scroll(direction) {
      const item = this.container.querySelector('.gallery__item');
      if (!item) return;
      
      // Calculate scroll based on item width plus gap
      const style = window.getComputedStyle(this.container);
      const gap = parseFloat(style.gap) || 0;
      const scrollAmount = item.offsetWidth + gap;
      
      this.container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if(window.innerWidth > 900) return; // Ignore on desktop where arrows are hidden

      const { scrollLeft, scrollWidth, clientWidth } = this.container;
      
      // Disable/Dim prev button if at the beginning
      if (scrollLeft <= 0) {
        this.prevBtn.style.opacity = '0.3';
        this.prevBtn.style.pointerEvents = 'none';
      } else {
        this.prevBtn.style.opacity = '1';
        this.prevBtn.style.pointerEvents = 'auto';
      }

      // Disable/Dim next button if at the end (+1 buffer added for sub-pixel browser rendering)
      if (Math.ceil(scrollLeft + clientWidth + 1) >= scrollWidth) {
        this.nextBtn.style.opacity = '0.3';
        this.nextBtn.style.pointerEvents = 'none';
      } else {
        this.nextBtn.style.opacity = '1';
        this.nextBtn.style.pointerEvents = 'auto';
      }
    }
  }
  if (!customElements.get('gallery-mobile-slider')) {
    customElements.define('gallery-mobile-slider', GalleryMobileSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide-2025-template-navigation"]) return;
  try {
    
  class GiftGuideNavigation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.giftUnder75 = document.querySelector('#main-content .static-banner-with-product-grid');
      this.specialEdition = document.querySelector('#main-content .special-edition-products');
      this.deviceSets = document.querySelector('#main-content .static-banner-with-product-grid:last-of-type');

      this.addEventListener('click', this.clickEventHandler.bind(this));
    }

    clickEventHandler(event) {
      const btn = event.target.closest('button');
      if (!btn) return;
      const { targetSection } = btn.dataset;

      if (targetSection == 'gift-under-75') {
        this.giftUnder75.scrollIntoView({
          behavior: 'smooth',
        });
        return;
      }

      if (targetSection == 'device-sets') {
        this.deviceSets.scrollIntoView({
          behavior: 'smooth',
        });
        return;
      }

      if (targetSection == 'limited-edition') {
        this.specialEdition.scrollIntoView({
          behavior: 'smooth',
        });
        return;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.clickEventHandler.bind(this));
    }
  }
  customElements.define('gift-guide-navigation', GiftGuideNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-with-statistics"] && !Shopify.designMode) return;
  try {
    
  class StatisticAnimation extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('.results-with-statistics');
    }

    connectedCallback() {
      this.statistic = parseInt(this.dataset.statistic, 10);
      this.container = this.querySelector('span:first-of-type');

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.initAnimation();
              this.observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '0px 0px -50px 0px',
        }
      );
      this.observer.observe(this.parent);
    }

    initAnimation() {
      const duration = 1200;
      const start = performance.now();
      const endValue = this.statistic;
      const span = this.container;

      const easeOutQuad = (t) => t * (2 - t);
      const step = (timestamp) => {
        const progress = Math.min((timestamp - start) / duration, 1);
        const eased = easeOutQuad(progress);
        const current = Math.round(eased * endValue);
        span.textContent = current < 10 ? `0${current}%` : `${current}%`;
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };
      requestAnimationFrame(step);
    }
  }
  if (!customElements.get('statistic-animation')) {
    customElements.define('statistic-animation', StatisticAnimation);
  }

  class ResultsMobileSlider extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.results-with-statistics--columns');
      this.prevBtn = this.querySelector('.results-slider-arrow.prev');
      this.nextBtn = this.querySelector('.results-slider-arrow.next');

      if (!this.container || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this.scroll('left'));
      this.nextBtn.addEventListener('click', () => this.scroll('right'));

      this.container.addEventListener('scroll', this.updateButtons.bind(this), { passive: true });
      
      // Initial button state check
      setTimeout(() => this.updateButtons(), 100);
    }

    scroll(direction) {
      const item = this.container.querySelector('.results-with-statistics--item');
      if (!item) return;
      
      // Calculate scroll based on item width plus gap (30px)
      const scrollAmount = item.offsetWidth + 30;
      
      this.container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if(window.innerWidth > 900) return; // Ignore on desktop where arrows are hidden

      const { scrollLeft, scrollWidth, clientWidth } = this.container;
      
      // Disable/Dim prev button if at the beginning
      if (scrollLeft <= 0) {
        this.prevBtn.style.opacity = '0.3';
        this.prevBtn.style.pointerEvents = 'none';
      } else {
        this.prevBtn.style.opacity = '1';
        this.prevBtn.style.pointerEvents = 'auto';
      }

      // Disable/Dim next button if at the end
      if (Math.ceil(scrollLeft + clientWidth) >= scrollWidth) {
        this.nextBtn.style.opacity = '0.3';
        this.nextBtn.style.pointerEvents = 'none';
      } else {
        this.nextBtn.style.opacity = '1';
        this.nextBtn.style.pointerEvents = 'auto';
      }
    }
  }
  if (!customElements.get('results-mobile-slider')) {
    customElements.define('results-mobile-slider', ResultsMobileSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-edition-products"] && !Shopify.designMode) return;
  try {
    
  class SpecialEditionCta extends HTMLElement {
    constructor() {
      super();
      this.sectionsToRender = [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-content',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-footer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ];
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.buttonEventHandler.bind(this));
    }

    buttonEventHandler(event) {
      const btn = event.target.closest('button');
      if (!btn) return;
      const { variantId } = btn.dataset;
      this.addToCart(variantId);
    }

    async addToCart(variantId) {
      this.button.disabled = true;
      this.button.classList.add('loading');
      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: this.sectionsToRender.map((t) => t.section),
        sections_url: window.location.pathname,
      };

      try {
        const req = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const resp = await req.json();
        this.renderCartDrawer(resp);
      } catch (error) {
        console.log(`Add To Cart | ${error}`);
      } finally {
        this.button.disabled = false;
        this.button.classList.remove('loading');
      }
    }

    renderCartDrawer(resp) {
      this.sectionsToRender.forEach((e) => {
        if (!document.getElementById(e.id)) return;
        let i = document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id);
        (i.innerHTML = this.getSectionInnerHTML(resp.sections[e.section], e.selector)),
          'undefined' != typeof CartDrawer && new CartDrawer(),
          'undefined' != typeof Cart && new Cart().renderContents(resp);
      });
      let e = document.getElementById('Product-Drawer');
      e && e.contains(this)
        ? (e.querySelector('.product-quick-images--container').classList.remove('active'),
          document.body.classList.remove('open-quick-view'),
          window.innerWidth < 1069
            ? (e.classList.remove('active'),
              document.getElementById('Cart-Drawer') &&
                (document.getElementById('Cart-Drawer').classList.add('active'),
                document.body.classList.add('open-cart'),
                document
                  .getElementById('Cart-Drawer')
                  .querySelector('.product-recommendations--full')
                  .classList.add('active'),
                dispatchCustomEvent('cart-drawer:open')))
            : e.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
                e.classList.remove('active'),
                  document.getElementById('Cart-Drawer') &&
                    (document.getElementById('Cart-Drawer').classList.add('active'),
                    document.body.classList.add('open-cart'),
                    document
                      .getElementById('Cart-Drawer')
                      .querySelector('.product-recommendations--full')
                      .classList.add('active'),
                    dispatchCustomEvent('cart-drawer:open'));
              }),
          document.getElementById('Cart-Drawer') || document.body.classList.remove('open-cc'))
        : document.getElementById('Cart-Drawer') &&
          (document.body.classList.add('open-cc'),
          document.body.classList.add('open-cart'),
          document.getElementById('Cart-Drawer').classList.add('active'),
          dispatchCustomEvent('cart-drawer:open'));
    }

    getSectionInnerHTML(t, e = '.shopify-section') {
      return new DOMParser().parseFromString(t, 'text/html').querySelector(e).innerHTML;
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.buttonEventHandler.bind(this));
    }
  }
  customElements.define('special-edition-product-atc', SpecialEditionCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-banner-with-carousel"] && !Shopify.designMode) return;
  try {
    
  class StaticBannerWithCarousel extends HTMLElement {
    constructor() {
      super();
      this.sectionsToRender = [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-content',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-footer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ];
    }

    connectedCallback() {
      this.arrows = this.querySelector('.global-static-banner-with-carousel--arrows');
      this.carousel = this.querySelector('.global-static-banner-with-carousel--carousel');
      this.items = Array.from(this.carousel.querySelectorAll('.global-static-banner-with-carousel--carousel-item'));

      this.addEventListener('click', this.componentClickEventListenerHandler.bind(this));
      this.arrows.addEventListener('click', this.arrowsEventHandler.bind(this));
      this.carousel.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    componentClickEventListenerHandler(event) {
      const btn = event.target.closest('.global-static-banner-with-carousel--carousel-item-cta');
      if (!btn) return;
      const { variantId } = btn.dataset;
      this.addToCart(variantId, btn);
    }

    // Use viewport-relative delta so it's correct after every scroll/snapping
    arrowsEventHandler(event) {
      const btn = event.target.closest('button');
      if (!btn) return;

      const isNext = btn.classList.contains('next-slide');
      const target = this.getAdjacentItem(isNext);
      if (!target) return;

      const cRect = this.carousel.getBoundingClientRect();
      const tRect = target.getBoundingClientRect();
      const delta = tRect.left - cRect.left;

      // If we're already aligned, do nothing
      if (Math.abs(delta) <= 1) return;

      this.carousel.scrollBy({
        left: delta,
        behavior: 'smooth',
      });
    }

    // Decide next/prev using DOMRects (robust against scrollLeft/offsetLeft quirks)
    getAdjacentItem(isNext) {
      if (!this.items?.length) return null;

      const cRect = this.carousel.getBoundingClientRect();
      const EPS = 2;

      // Left position of each item relative to the carousel's viewport
      const rel = this.items
        .map((el) => ({ el, left: el.getBoundingClientRect().left - cRect.left }))
        .sort((a, b) => a.left - b.left);

      if (isNext) {
        // First item whose left edge is to the right of the viewport start
        for (const r of rel) {
          if (r.left > EPS) return r.el;
        }
        return this.items[this.items.length - 1];
      } else {
        // Closest item whose left edge is left of the viewport start
        let prev = null;
        for (const r of rel) {
          if (r.left >= -EPS) break;
          prev = r.el;
        }
        return prev || this.items[0];
      }
    }

    // Use viewport visibility of first/last items (not scrollWidth math)
    updateArrows() {
      const prevBtn = this.arrows.querySelector('.prev-slide');
      const nextBtn = this.arrows.querySelector('.next-slide');
      if (!prevBtn || !nextBtn || !this.items?.length) return;

      const EPS = 2;
      const cRect = this.carousel.getBoundingClientRect();
      const firstRect = this.items[0].getBoundingClientRect();
      const lastRect = this.items[this.items.length - 1].getBoundingClientRect();

      const atStart = firstRect.left >= cRect.left - EPS;
      const atEnd = lastRect.right <= cRect.right + EPS;

      prevBtn.toggleAttribute('disabled', atStart);
      prevBtn.setAttribute('aria-disabled', String(atStart));

      nextBtn.toggleAttribute('disabled', atEnd);
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    }

    async addToCart(variantId, btn) {
      btn.disabled = true;
      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: this.sectionsToRender.map((t) => t.section),
        sections_url: window.location.pathname,
      };

      try {
        const req = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const resp = await req.json();
        this.renderCartDrawer(resp);
      } catch (error) {
        console.log(`Static Banner with Carousel | addToCart | ${error}`);
      } finally {
        btn.disabled = false;
      }
    }

    renderCartDrawer(resp) {
      this.sectionsToRender.forEach((e) => {
        if (!document.getElementById(e.id)) return;
        let i = document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id);
        (i.innerHTML = this.getSectionInnerHTML(resp.sections[e.section], e.selector)),
          'undefined' != typeof CartDrawer && new CartDrawer(),
          'undefined' != typeof Cart && new Cart().renderContents(resp);
      });
      let e = document.getElementById('Product-Drawer');
      e && e.contains(this)
        ? (e.querySelector('.product-quick-images--container').classList.remove('active'),
          document.body.classList.remove('open-quick-view'),
          window.innerWidth < 1069
            ? (e.classList.remove('active'),
              document.getElementById('Cart-Drawer') &&
                (document.getElementById('Cart-Drawer').classList.add('active'),
                document.body.classList.add('open-cart'),
                document
                  .getElementById('Cart-Drawer')
                  .querySelector('.product-recommendations--full')
                  .classList.add('active'),
                dispatchCustomEvent('cart-drawer:open')))
            : e.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
                e.classList.remove('active'),
                  document.getElementById('Cart-Drawer') &&
                    (document.getElementById('Cart-Drawer').classList.add('active'),
                    document.body.classList.add('open-cart'),
                    document
                      .getElementById('Cart-Drawer')
                      .querySelector('.product-recommendations--full')
                      .classList.add('active'),
                    dispatchCustomEvent('cart-drawer:open'));
              }),
          document.getElementById('Cart-Drawer') || document.body.classList.remove('open-cc'))
        : document.getElementById('Cart-Drawer') &&
          (document.body.classList.add('open-cc'),
          document.body.classList.add('open-cart'),
          document.getElementById('Cart-Drawer').classList.add('active'),
          dispatchCustomEvent('cart-drawer:open'));
    }

    getSectionInnerHTML(t, e = '.shopify-section') {
      return new DOMParser().parseFromString(t, 'text/html').querySelector(e).innerHTML;
    }

    disconnectedCallback() {}
  }

  if (!customElements.get('global-static-banner-with-carousel')) {
    customElements.define('global-static-banner-with-carousel', StaticBannerWithCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-banner-with-product-grid"] && !Shopify.designMode) return;
  try {
    
  class StaticBannerProductGridCta extends HTMLElement {
    constructor() {
      super();
      this.sectionsToRender = [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-content',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-footer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ];
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.buttonEventHandler.bind(this));
    }

    buttonEventHandler(event) {
      const btn = event.target.closest('button');
      if (!btn) return;
      const { variantId } = btn.dataset;
      this.addToCart(variantId);
    }

    async addToCart(variantId) {
      this.button.disabled = true;
      this.button.classList.add('loading');
      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: this.sectionsToRender.map((t) => t.section),
        sections_url: window.location.pathname,
      };

      try {
        const req = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const resp = await req.json();
        this.renderCartDrawer(resp);
      } catch (error) {
        console.log(`Add To Cart | ${error}`);
      } finally {
        this.button.disabled = false;
        this.button.classList.remove('loading');
      }
    }

    renderCartDrawer(resp) {
      this.sectionsToRender.forEach((e) => {
        if (!document.getElementById(e.id)) return;
        let i = document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id);
        (i.innerHTML = this.getSectionInnerHTML(resp.sections[e.section], e.selector)),
          'undefined' != typeof CartDrawer && new CartDrawer(),
          'undefined' != typeof Cart && new Cart().renderContents(resp);
      });
      let e = document.getElementById('Product-Drawer');
      e && e.contains(this)
        ? (e.querySelector('.product-quick-images--container').classList.remove('active'),
          document.body.classList.remove('open-quick-view'),
          window.innerWidth < 1069
            ? (e.classList.remove('active'),
              document.getElementById('Cart-Drawer') &&
                (document.getElementById('Cart-Drawer').classList.add('active'),
                document.body.classList.add('open-cart'),
                document
                  .getElementById('Cart-Drawer')
                  .querySelector('.product-recommendations--full')
                  .classList.add('active'),
                dispatchCustomEvent('cart-drawer:open')))
            : e.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
                e.classList.remove('active'),
                  document.getElementById('Cart-Drawer') &&
                    (document.getElementById('Cart-Drawer').classList.add('active'),
                    document.body.classList.add('open-cart'),
                    document
                      .getElementById('Cart-Drawer')
                      .querySelector('.product-recommendations--full')
                      .classList.add('active'),
                    dispatchCustomEvent('cart-drawer:open'));
              }),
          document.getElementById('Cart-Drawer') || document.body.classList.remove('open-cc'))
        : document.getElementById('Cart-Drawer') &&
          (document.body.classList.add('open-cc'),
          document.body.classList.add('open-cart'),
          document.getElementById('Cart-Drawer').classList.add('active'),
          dispatchCustomEvent('cart-drawer:open'));
    }

    getSectionInnerHTML(t, e = '.shopify-section') {
      return new DOMParser().parseFromString(t, 'text/html').querySelector(e).innerHTML;
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.buttonEventHandler.bind(this));
    }
  }
  customElements.define('static-banner-product-grid-cta', StaticBannerProductGridCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  class VideoReelItem extends HTMLElement {
    constructor() {
      super();
      this.parentComponent = this.closest('video-reels');
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.icon = this.querySelector('.video-reels-container--play-icon');

      this.icon.addEventListener('click', () => {
        this.hidePlayIcon();
        this.video.play();
      });

      this.video.addEventListener('play', () => {
        this.hidePlayIcon();
        this.stopSiblingsVideos(this.video);
      });
      this.video.addEventListener('pause', () => {
        this.showPlayIcon();
      });
      this.video.addEventListener('ended', () => {
        this.showPlayIcon();
      });
    }

    disconnectedCallback() {
      this.video.removeEventListener('play', () => {
        this.hidePlayIcon();
        this.stopSiblingsVideos(this.video);
      });
      this.video.removeEventListener('pause', () => {
        this.showPlayIcon();
      });
      this.video.removeEventListener('ended', () => {
        this.showPlayIcon();
      });
    }

    stopSiblingsVideos(currentVideo) {
      this.parentComponent.querySelectorAll('video-reel-item').forEach((component) => {
        let video = component.querySelector('video');
        if (video !== currentVideo && !video.paused) {
          component.pauseVideo();
          component.showPlayIcon();
        }
      });
    }

    showPlayIcon() {
      this.icon.classList.remove('hide-play-icon');
    }

    hidePlayIcon() {
      this.icon.classList.add('hide-play-icon');
    }

    pauseVideo() {
      this.video.pause();
    }
  }
  customElements.define('video-reel-item', VideoReelItem);

  } catch(e) { console.error(e); }
})();
})();
